// extracted by mini-css-extract-plugin
module.exports = {"toastContainer":"index_toastContainer__hJ3BQ","msg":"index_msg__33oew","simpleToast":"index_simpleToast__307Wh"};